import { CONFIRMATION_RESULT } from "@wizeoo/akm-core-lib";

/**
 * Objet de retour sur popUp de confirmation.
 * Contient le code de l'action choisie, et la data d'origine
 */
export class ConfirmationResultObj {
  /** selection result */
  result: CONFIRMATION_RESULT;

  /** les données sources  */
  data: any;

  public static build(result: CONFIRMATION_RESULT, data :any) : ConfirmationResultObj
  {
    const res:ConfirmationResultObj = new ConfirmationResultObj();
    res.result = result;
    res.data = data;
    return res;
  }
}
